var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentTextIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.6667 6.79333H11.74C10.16 6.79333 8.87333 5.50667 8.87333 3.92667V2C8.87333 1.63333 8.57333 1.33333 8.20667 1.33333H5.38C3.32667 1.33333 1.66667 2.66667 1.66667 5.04667V10.9533C1.66667 13.3333 3.32667 14.6667 5.38 14.6667H10.62C12.6733 14.6667 14.3333 13.3333 14.3333 10.9533V7.46C14.3333 7.09333 14.0333 6.79333 13.6667 6.79333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5331 1.47333C10.2598 1.2 9.78646 1.38666 9.78646 1.76666V4.09333C9.78646 5.06666 10.6131 5.87333 11.6198 5.87333C12.2531 5.88 13.1331 5.88 13.8865 5.88C14.2665 5.88 14.4665 5.43333 14.1998 5.16666C13.2398 4.2 11.5198 2.46 10.5331 1.47333Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.16667H5C4.72667 9.16667 4.5 8.94 4.5 8.66667C4.5 8.39333 4.72667 8.16667 5 8.16667H9C9.27333 8.16667 9.5 8.39333 9.5 8.66667C9.5 8.94 9.27333 9.16667 9 9.16667Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 11.8333H5C4.72667 11.8333 4.5 11.6067 4.5 11.3333C4.5 11.06 4.72667 10.8333 5 10.8333H7.66667C7.94 10.8333 8.16667 11.06 8.16667 11.3333C8.16667 11.6067 7.94 11.8333 7.66667 11.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentTextIcon);
export default __webpack_public_path__ + "static/media/document-text-icon.0d49e38eb3126800d2d278329f3327fb.svg";
export { ForwardRef as ReactComponent };